<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>添加跟踪记录-试听课成功预约提醒记录</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formValidate" :label-width="90" class="form">
      <Row>
        <Col :sm="11" :md="5">
        <Form-item label="学生ID" prop="uid">
          <Input v-model.number="formValidate.uid" :maxlength="10"></Input>
        </Form-item>
        </Col>
        <Col :sm="11" :md="5">
        <Form-item label="学生姓名" prop="nickname">
          <Input readonly placeholder="只读"
                 v-model="formValidate.nickname" ></Input>
        </Form-item>
        </Col>
        <Col :sm="11" :md="5">
        <Form-item label="课程顾问" prop="adviserName">
          <Input readonly placeholder="只读"
                 v-model="formValidate.adviserName"></Input>
        </Form-item>
        </Col>
        <Col :sm="11" :md="5">
        <Form-item label="学习导师" prop="studyAdviserName">
          <Input readonly placeholder="只读"
                 v-model="formValidate.studyAdviserName"></Input>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item label="所处年级:">
          <CheckBox :boxList="grades" @on-select-change="onGradeChange"></CheckBox>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item label="学习经历:">
          <CheckBox :boxList="studyExperience" @on-select-change="onStudyExperienceChange"></CheckBox>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item label="孩子性格:">
          <CheckBox :boxList="studentNature" @on-select-change="onStudentNature"></CheckBox>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item label="兴趣爱好:">
          <CheckBox :boxList="hobby" @on-select-change="onHobbyChange"></CheckBox>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item label="老师要求:">
          <CheckBox :boxList="tchRequirement" @on-select-change="ontchRequirementChange"></CheckBox>
        </Form-item>
        </Col>
      </Row>
        <Row>
          <Col :sm="11" :md="6">
          <Form-item label="下次联系日期">
          <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                       @on-change="dateChange"
                       :value="formData.nextTimeDate"></Date-picker>
          </Form-item>
          </Col>
          <Col :sm="11" :md="6">
          <Form-item label="状态" prop="status">
            <Select v-model.number="formData.state">
              <Option v-for="item in $constant.handlerType" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :sm="11" :md="6">
            <Form-item style="text-align: center">
              <Button type="primary" @click="handleSubmit">提交</Button>
            </Form-item>
          </Col>
        </row>
    </Form>
  </div>
</template>
<script>
  import Checkbox from 'iview/src/components/checkbox'
  import commonUtils from '@/tools/commonUtils.js'
  export default {
    components: {Checkbox},
    data () {
      return {
        checkBoxes: [],
        studentNature: [],
        studyExperience: [],
        hobby: [],
        grades: [],
        englishLevel: [],
        tchRequirement: [],
        formData: {
          uid: '',
          nickName: '',
          nextTimeDate: '',
          studentNatureList: [],
          studyExperienceList: [],
          hobbyList: [],
          gradesList: [],
          englishLevelList: [],
          tchRequirementList: [],
        },
        formValidate: {
          uid: '',
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
        },
      }
    },
    created () {
      let self = this
      self.$http.get('/adminConfig/getItemByItemType?itemType=' + 1).then(function (res) {
        self.checkBoxes = res.data
        self.classifyBox(self.checkBoxes)
      })
    },
    mounted () {
      let self = this
      let row = self.$route.query.row
      self.formValidate.uid = row.uid
      self.formData.uid = row.uid
      self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
        self.formValidate.nickname = res.data.nickname
        self.formData.nickName = self.formValidate.nickname
        self.formValidate.adviserName = res.data.adviserName
        self.formValidate.studyAdviserName = res.data.studyAdviserName
      })
    },
    methods: {
      dateChange (value) {
        this.formData.nextTimeDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onGradeChange (val) {
        this.formData.gradesList = val
      },
      onStudyExperienceChange (val) {
        this.formData.studyExperienceList = val
      },
      onStudentNature (val) {
        this.formData.studentNatureList = val
      },
      onHobbyChange (val) {
        this.formData.hobbyList = val
      },
      onEnglishLevelChange (val) {
        this.formData.englishLevelList = val
      },
      ontchRequirementChange (val) {
        this.formData.tchRequirementList = val
      },
      classifyBox (checkBoxes) {
        let self = this
        for (var index = 0; index < checkBoxes.length; index++) {
          if (checkBoxes[index].parentTitle === '学习经历') {
            self.studyExperience.push(checkBoxes[index])
          }
          if (checkBoxes[index].parentTitle === '孩子性格') {
            self.studentNature.push(checkBoxes[index])
          }
          if (checkBoxes[index].parentTitle === '兴趣爱好') {
            self.hobby.push(checkBoxes[index])
          }
          if (checkBoxes[index].parentTitle === '所处年级') {
            self.grades.push(checkBoxes[index])
          }
          if (checkBoxes[index].parentTitle === '老师要求') {
            self.tchRequirement.push(checkBoxes[index])
          }
        }
      },
      handleSubmit () {
        let self = this
        self.$http.post('/userList/insertUserModal', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.formData)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          self.loadingBind = false
          if (!res) {
            self.$Message.error('操作失败!')
          } else if (res.data > 0) {
            self.$Message.success('添加成功!')
            self.visible = false
            if (self.successCallback !== undefined) {
              self.successCallback()
            }
            self.$router.push({path: '/message/personMessage', query: {tabName: commonUtils.getShortNumByTraceType(21)}})
          } else {
            self.$Message.error(res.message)
          }
        })
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// EditStudentInfo.vue?6ff70dbb